import { AxiosResponse } from 'axios';
import { FEATURES_BY_PLAN } from '../../../../../config';
import { OrganizationScope } from '../../../../../v2/app';
import { BillingSubscriptionPlan } from '../../../../domain/billing';
import { PlanAdapter } from '../../../../app/billing';
import { PlanApiAdapterConfig } from './planApiConfig';

export function createSubscriptionPlanImpl(config: PlanApiAdapterConfig): PlanAdapter {
    async function getHeaders(context: OrganizationScope) {
        if (context.auth.scheme.kind === 'legacy') {
            await context.auth.scheme.store.waitAuthenticated();
            return {
                Authorization: `bearer ${context.auth.scheme.store.authToken}`,
            };
        }
        throw Error('scheme not implemented ' + context.auth.scheme.kind);
    }
    return {
        async find(context, query) {
            const headers = await getHeaders(context);
            const params: Record<string, unknown> = {};
            if (query.version) {
                params['version'] = query.version;
            }
            const response = await config.axios.get<
                unknown,
                AxiosResponse<{ items: Omit<BillingSubscriptionPlan, 'features'>[] }>
            >(`/api/v1/billing/plans`, { params, headers });

            return response.data.items.map(
                (item): BillingSubscriptionPlan => ({
                    ...item,
                    // features: [],
                    features:
                        FEATURES_BY_PLAN[item.id]?.map((feature) => ({
                            id: 'feature',
                            name: feature.text,
                            description: feature.caption ?? null,
                            enabled: true,
                        })) ?? [],
                })
            );
        },
    };
}
